// extracted by mini-css-extract-plugin
export var loadingSpinner = "_w-0";